import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Loader, Modal } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import moment from 'moment';
import SettingsCard from './SettingsCard';
import Strings from '../../common/Strings';
import { paymentActions } from '../../actions';
import { history } from '../../helpers';
import { getPlanInfo } from '../../helpers/subscription';

class PlanAndBillingPlan extends Component {
  constructor(props) {
    super(props);

    this.state = {
      downgradeModalOpen: false,
    };
  }

  renderDowngradeModal() {
    const downgrade = () => {
      this.setState({ downgradeModalOpen: false });
      this.props.dispatch(paymentActions.cancelSubscription());
    };
    return (
      <Modal
        centered
        size="mini"
        open={this.state.downgradeModalOpen}
        closeIcon
        onClose={() => {
          this.setState({ downgradeModalOpen: false });
        }}
      >
        <div className="plan-and-billing-danger-modal-title">
          {Strings.BILLING.downgradeTitle}
        </div>
        <div className="common-modal-root plan-and-billing-modal-danger-root">
          <div className="plan-and-billing-modal-section">
            <div className="plan-and-billing-modal-section-danger-container">
              <p className="common-modal-title plan-and-billing-modal-section-danger-title">
                {Strings.BILLING.downgradeWarning}
              </p>
              <p className="common-modal-body plan-and-billing-modal-section-danger-body">
                {Strings.BILLING.downgradeWarningDetail}
              </p>
            </div>
          </div>
          <div className="plan-and-billing-modal-button-container">
            <Button
              className="common-grey-button"
              onClick={() => {
                this.setState({ downgradeModalOpen: false });
              }}
            >
              {Strings.BILLING.cancel}
            </Button>
            <div style={{ width: 30 }} />
            <Button
              className="common-red-button plan-and-billing-danger-modal-confirm-button"
              onClick={() => {
                downgrade();
              }}
            >
              {Strings.BILLING.continue}
            </Button>
          </div>
        </div>
      </Modal>
    );
  }

  render() {
    let subscriptionButtonText;
    let buttonAction;
    let buttonClass = '';
    const { subscription, upcomingInvoice } = this.props;

    // SUBSCRIPTION STATUS
    const { planText } = getPlanInfo(subscription);
    const statusInactive = subscription.status === 'inactive';
    const statusActive = subscription.status === 'active';
    const statusFailedPayment =
      subscription.status === 'incomplete' ||
      subscription.status === 'past_due';
    const willCancel = subscription.cancelAtPeriodEnd;

    if (statusInactive) {
      subscriptionButtonText = Strings.BILLING.upgradeToPremium;
      buttonAction = 'upgrade';
    } else if (statusFailedPayment) {
      subscriptionButtonText = Strings.BILLING.retry;
      buttonAction = 'retry';
      buttonClass = ' common-warning-circle-small';
    } else if (statusActive && !willCancel) {
      subscriptionButtonText = Strings.BILLING.downgrade;
      buttonAction = 'downgrade';
    } else if (statusActive && willCancel) {
      subscriptionButtonText = Strings.BILLING.restoreSubscription;
      buttonAction = 'restore';
    } else {
      subscriptionButtonText = Strings.BILLING.upgradeToPremium;
      buttonAction = 'upgrade';
    }

    const subscriptionButtonClick = () => {
      switch (buttonAction) {
        case 'retry':
          this.props.dispatch(paymentActions.retryPayment());
          break;
        case 'downgrade':
          this.setState({ downgradeModalOpen: true });
          break;
        default:
          history.push('#premium');
      }
    };

    let SubscriptionStatus;
    if (this.props.subscriptionLoading) {
      SubscriptionStatus = (
        <div className="plan-and-billing-card-row">
          <Loader inline active size="large" />
        </div>
      );
    } else if (this.props.subscriptionFailed) {
      SubscriptionStatus = (
        <div className="plan-and-billing-card-row">
          <p className="settings-card-subtitle">
            {Strings.BILLING.currentPlan}
          </p>
          <p className="plan-and-billing-card-row-value-bold">
            <img
              className="plan-and-billing-inline-error-icon"
              src="/error/icon_alert.png"
              alt=""
            />{' '}
            {Strings.BILLING.planError}
          </p>
        </div>
      );
    } else if (subscription) {
      SubscriptionStatus = (
        <div className="plan-and-billing-card-row">
          <p className="settings-card-subtitle">
            {Strings.BILLING.currentPlan}
          </p>
          <p className="plan-and-billing-card-row-value-bold">{planText}</p>
          <Button
            className={`common-light-button${buttonClass}`}
            onClick={() => subscriptionButtonClick()}
          >
            {subscriptionButtonText}
          </Button>
          {statusFailedPayment && (
            <a
              id="plan-and-billing-subscription-button-side-link"
              onClick={() =>
                this.props.dispatch(paymentActions.endSubscription())
              }
            >
              {Strings.BILLING.endSubscription}
            </a>
          )}
        </div>
      );
    }

    // UPCOMING INVOICE

    let UpcomingInvoiceDate;
    if (this.props.upcomingInvoiceLoading) {
      UpcomingInvoiceDate = <Loader inline active size="tiny" />;
    } else if (this.props.upcomingInvoiceFailed) {
      UpcomingInvoiceDate = (
        <span>
          <img
            className="plan-and-billing-inline-error-icon"
            src="/error/icon_alert.png"
            alt=""
          />{' '}
          {Strings.BILLING.upcomingInvoiceError}
        </span>
      );
    } else if (upcomingInvoice) {
      UpcomingInvoiceDate = moment(upcomingInvoice.nextPaymentAttempt).format(
        'MMM D, YYYY',
      );
    } else {
      UpcomingInvoiceDate = 'N/A';
    }

    // RENDER
    return (
      <SettingsCard id="plan-and-billing-plan-section">
        {SubscriptionStatus}
        <div className="plan-and-billing-card-row">
          <p className="settings-card-subtitle">
            {Strings.BILLING.nextBillingDate}
          </p>
          <p className="plan-and-billing-card-row-value">
            {UpcomingInvoiceDate}
          </p>
        </div>
        {this.renderDowngradeModal()}
      </SettingsCard>
    );
  }
}

PlanAndBillingPlan.defaultProps = {
  upcomingInvoice: null,
};

PlanAndBillingPlan.propTypes = {
  dispatch: PropTypes.func.isRequired,
  subscription: PropTypes.shape({
    status: PropTypes.string,
    cancelAtPeriodEnd: PropTypes.bool,
  }).isRequired,
  subscriptionLoading: PropTypes.bool.isRequired,
  subscriptionFailed: PropTypes.bool.isRequired,
  upcomingInvoice: PropTypes.shape({
    nextPaymentAttempt: PropTypes.number,
  }),
  upcomingInvoiceLoading: PropTypes.bool.isRequired,
  upcomingInvoiceFailed: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  subscription: state.premiumSubscription.subscription,
  subscriptionLoading: state.premiumSubscription.loading,
  subscriptionFailed: state.premiumSubscription.failed,
  upcomingInvoice: state.upcomingInvoice.upcoming,
  upcomingInvoiceLoading: state.upcomingInvoice.loading,
  upcomingInvoiceFailed: state.upcomingInvoice.failed,
});

export default connect(mapStateToProps)(PlanAndBillingPlan);



// WEBPACK FOOTER //
// ./src/components/settings/PlanAndBillingPlan.js